/* línkè · 我们的相册 · 纯工具层（2026-07-12）
   页面在 Album.jsx；这里只放能进单测的纯函数。 */

export const MAX_PHOTOS = 9;

/** 照片格子的布局类（朋友圈式）：1 张=大图，2/4 张=两列，其余=三列。 */
export function gridClass(n) {
  if (n <= 1) return 'one';
  if (n === 2 || n === 4) return 'two';
  return 'three';
}

/** 动态的日期行：今天 HH:MM / 昨天 HH:MM / M月D日 HH:MM（跨年带年）。 */
export function fmtPostDate(ts, now = new Date()) {
  const d = new Date(ts * 1000);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (x) => String(x).padStart(2, '0');
  const hm = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  const same = (a, b) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();
  if (same(d, now)) return `今天 ${hm}`;
  const ytd = new Date(now);
  ytd.setDate(now.getDate() - 1);
  if (same(d, ytd)) return `昨天 ${hm}`;
  if (d.getFullYear() === now.getFullYear())
    return `${d.getMonth() + 1} 月 ${d.getDate()} 日 ${hm}`;
  return `${d.getFullYear()} 年 ${d.getMonth() + 1} 月 ${d.getDate()} 日 ${hm}`;
}

/** 还能再选几张（选满 9 张为止）。 */
export function remainSlots(picked) {
  const n = Array.isArray(picked) ? picked.length : 0;
  return Math.max(0, MAX_PHOTOS - n);
}

/* ============================================================
   三期「真正两个人的相册」（2026-09-03）：相册视图的纯工具
   ============================================================ */

/** 「全部」这个虚拟相册的 key（不是真标签，代表不筛选）。 */
export const ALL_ALBUM = '__all__';

/** 按相册（标签）筛照片；ALL_ALBUM 或空 = 全部。 */
export function photosInAlbum(photos, album) {
  if (!Array.isArray(photos)) return [];
  if (!album || album === ALL_ALBUM) return photos;
  return photos.filter((p) => Array.isArray(p.tags) && p.tags.includes(album));
}

/** 在一组标签里加/去一个（用于照片详情里「移到相册」的多选）。 */
export function toggleTag(tags, tag) {
  const t = Array.isArray(tags) ? tags : [];
  return t.includes(tag) ? t.filter((x) => x !== tag) : [...t, tag];
}

/** 谁放进来的：她放的 / 克克收的（by 缺省当她放的）。 */
export function byLabel(by) {
  return by === 'sael' ? '克克收进来的' : '你放进来的';
}
